module.exports = __webpack_public_path__ + "static/media/project-audioreactiveroom.d659f4a6.jpg";